module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    style: ({
      'minHeight': _vm.minHeight
    })
  }, [(_vm.config_info) ? [(_vm.showPC) ? [_c('transition', {
    attrs: {
      "name": "router-fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)] : _vm._e()] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ced6bc0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 620
// module chunks = 31